import { useTranslation } from "react-i18next";

import GaiaPageGridComponent from "~/modules/app/components/GaiaPageGridComponent";
import GaiaPageLayoutColumn from "~/modules/app/components/GaiaPageLayoutColumn";

import SettingsOptionsList from "../../components/SettingsOptionsList";

export default function SettingsListRoute() {
    const { t } = useTranslation("settings");

    return (
        <GaiaPageLayoutColumn>
            <GaiaPageGridComponent title={t("settingsListRoute.title")}>
                <SettingsOptionsList />
            </GaiaPageGridComponent>
        </GaiaPageLayoutColumn>
    );
}
